export default "__VITE_ASSET__D95D1MQN__"